import { Component, OnInit, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { UntypedFormGroup } from '@angular/forms';
import { erreursCroiseesLibelle } from '../../questionnaire.metadata';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-affiche-erreurs-croisees',
  templateUrl: './affiche-erreurs-croisees.component.html',
  styleUrls: ['./affiche-erreurs-croisees.component.css']
})
export class AfficheErreursCroiseesComponent implements OnInit {
  @Input()
  labelErreur: string;
  @Input()
  colorErreur: string;
  @Input()
  rootForm: UntypedFormGroup;
  constructor(private formulaireService: FormulaireService,
    public modeRendu: ModeRenduService
    ) {
  }

  ngOnInit() {
    if (! this.rootForm) {
      this.rootForm = this.formulaireService.getRootForm();
    }
  }

  public get erreursMap(): Map<string, string> {
    return erreursCroiseesLibelle;
  }


}
